import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, Col, Form, FormCheck, Row } from "react-bootstrap";
import EditBotTemplate from "../edit/EditBotTemplate";
import "./TemplateRow.scss"
import { TemplateStatus } from "../../../Const";
const TemplateRow = (props)=>{
    const {template,onEditClick,clickDelete,viewSettings,t} = props;
    //console.log(clickEditTemplate)
    const [showOptionMenu,setShowOptionMenu] = useState(false)
    const showOptions = ()=>{
        showOptionMenu?setShowOptionMenu(false):setShowOptionMenu(true)
    }
   
    return (
        <>
        
                <Col className="bot-template-list no-padding"  onMouseLeave={()=>setShowOptionMenu(false)}>
                    <div className="template-card">
                    
                    <div className="position-relative flex-center">
                    {showOptionMenu && <div className="template-edit-popup">
                                <ul>
                                    <li onClick={()=>viewSettings(template)}>{t("vs")}<span className="settings-icons" ><i className="fas fa-cog menu-icon"></i></span></li>
                                    <li onClick={()=>onEditClick(template)}>{t("edit")} <span className="settings-icons"><i className="far fa-edit"></i></span></li>
                                    <li className="delete-text" onClick={()=>clickDelete(template.id)}>Delete<span className="settings-icons"><i className="fas fa-trash menu-icon"></i></span></li>
                                </ul>
                            </div>}
                        <img src={template.image} className="template-list-bot-img mt-2 img-thumbnail no-border"></img>
                        <span className="pull-right bold"><span className="bold action-menu-icon" onClick={showOptions}><i className="fas fa-ellipsis-h menu-icon"></i></span></span>
                        <span className={`template-badge template-${template.status}`}>{t(TemplateStatus[template.status])}</span>
                    </div>
                        <Row noGutters>
                            <p>{template.title}</p>
                            </Row>
                            <Row>
                            <ul className="marketplac-card-info">
                                <li>
                                <div>{t("ar")}</div>
                                <div>{template.current_renter}</div>
                                </li>
                                <li>
                                <div>{t("life-earn")}</div>
                                <div>{template.lifetime_earn}</div>
                                </li>
                                <li>
                                <div>{t("strategy")}</div>
                                <div><span className={template.strategy=="Long"?"long":"short"}>{template.strategy}</span></div>
                                </li>
                            </ul>
                            </Row>
                    </div>
                </Col>
                
         </>
    )
}
export default connect(null,{})(TemplateRow)